module.exports = {"DASHBOARD":"Tableau de bord","DEALS":"Offres","SURVEYS":"Sondages","INVOICES":"Factures","OFFER":"Détails de l'offre","CHARTS":"Graphiques","TRANSACTIONS":"Transactions","CONTACT_US":"Contactez-nous","CLAIMS":"Offres réclamées","SALES":"Ventes"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/fr/nav.json
// module id = 355
// module chunks = 8